import * as ngCore from '@angular/core'

/**
 * Basic checkbox input.
 *
 * #### Inputs
 * - {@link Component.selectedSg selected}?
 * - {@link Component.disabledSg disabled}?
 * - {@link Component.someSelectedSg someSelected}?
 * - {@link Component.labelSg label}?
 *
 * #### Outputs
 * - {@link Component.selectedSg | selectedChange}
 *
 * @example
 * ```html
 * <atn-ds-checkbox
 *   label="Checkbox Input"
 *   [disabled]="false"
 *   [selected]="isChecked"
 *   (selectedChange)="handleSelect($event)"/>
 * ```
 */
@ngCore.Component({
  imports: [],
  selector: 'atn-ds-checkbox',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** Whether the checkbox is selected */
  public readonly selectedSg = ngCore.model(false, { alias: 'selected' })
  /** Whether the checkbox is disabled */
  public readonly disabledSg = ngCore.input(false, { alias: 'disabled' })
  /** Whether the checkbox shows an indeterminate dash state */
  public readonly someSelectedSg = ngCore.input(false, {
    alias: 'someSelected',
  })
  /** Label displayed next to the checkbox */
  public readonly labelSg = ngCore.input<string | undefined>(undefined, {
    alias: 'label',
  })

  /** Handles toggling the checkbox when the host is clicked. */
  public onCheckboxClickHandler(): void {
    this.selectedSg.update(value => !value)
  }
}
